import classNames from './AreYouSure.module.scss';
import mineClassNames from '../DeleteTeacherModal.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import TheButton from '@/components/school-management/TheButton/TheButton';
import { DeletedTeacherGroupData } from '@/school-management/types/response/teacher';
import { useMemo } from 'react';

interface AreYouSureProps {
  teacherName: string;
  groups: DeletedTeacherGroupData[];
  onConfirm: () => void;
  onCancel: () => void;
}

const AreYouSure = ({ teacherName, groups, onConfirm, onCancel }: AreYouSureProps) => {
  const { t } = useAdminTranslation();

  const descriptionData = useMemo(() => {
    return {
      numberOfStudents: groups.reduce((acc, group) => {
        return acc + group.studentCount;
      }, 0),
      numberOfClasses: groups.length,
    };
  }, [groups]);

  return (
    <div className={classNames.content}>
      <h2>{t('schoolDetailsPage.classes.deleteTeacherModal.areYouSure.title')}</h2>
      <span className={classNames.description}>
        {t('schoolDetailsPage.classes.deleteTeacherModal.areYouSure.description', {
          teacherName: teacherName,
          ...descriptionData,
        })}
      </span>
      <div className={mineClassNames.buttonsContainer}>
        <TheButton
          className={mineClassNames.okBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.ok')}
          shouldRecolor={false}
          emitOnClick={onConfirm}
        />
        <TheButton
          className={mineClassNames.cancelBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.cancel')}
          plain
          shouldRecolor={false}
          emitOnClick={onCancel}
        />
      </div>
    </div>
  );
};

export default AreYouSure;
